<script>
import Password from '@wielink-application/shared/vue/components/form/input-only/password.vue'

export default Password;
</script>